"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _Delete = _interopRequireDefault(require("../../icons/actions/Delete"));

var _styles = _interopRequireDefault(require("./styles"));

var _colors = _interopRequireDefault(require("../../styles/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tag = function Tag(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      onDeleteClick = _ref.onDeleteClick,
      small = _ref.small,
      props = _objectWithoutProperties(_ref, ["classes", "children", "onDeleteClick", "small"]);

  var iconSize = "".concat(small ? 8 : 10, "px");
  return _react["default"].createElement("div", _extends({
    className: classes.root
  }, props), _react["default"].createElement("span", {
    className: classes.text
  }, children), typeof onDeleteClick === 'function' && _react["default"].createElement(_Delete["default"], {
    className: classes.icon,
    height: iconSize,
    width: iconSize,
    color: _colors["default"].raven,
    onClick: onDeleteClick
  }));
};

Tag.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children of Tag component */
  children: _propTypes["default"].string.isRequired,

  /** Callback that is called when close icon is clicked, also controls whether to show the close icon or not */
  onDeleteClick: _propTypes["default"].func,

  /** small makes the entire tag a little smaller, including height, font size, icon size, etc. */
  small: _propTypes["default"].bool
};
Tag.defaultProps = {
  onDeleteClick: null,
  small: false
};

var _default = (0, _withStyles["default"])(_styles["default"])(Tag);

exports["default"] = _default;